export function getRelativeTime(value) {
  const now = new Date();
  const date = new Date(value);

  if (!value || isNaN(date.getTime())) {
    return '';
  }

  const locale = navigator.language;
  const diffInMilliSecs = date.getTime() - now.getTime();
  const diffInSecs = Math.trunc(diffInMilliSecs / 1000);

  const absDiffInSecs = Math.abs(diffInSecs);

  switch (true) {
    case absDiffInSecs < 60: {
      const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      return formatter.format(diffInSecs, 'second');
    }

    case absDiffInSecs >= 60 && absDiffInSecs < 3600: {
      const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      const minutes = Math.trunc(diffInSecs / 60);

      return formatter.format(minutes, 'minute');
    }

    case absDiffInSecs > 3600 && absDiffInSecs < 86400: {
      const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      const hours = Math.trunc(diffInSecs / 3600);

      return formatter.format(hours, 'hour');
    }

    case absDiffInSecs >= 86400 && absDiffInSecs < 604800: {
      const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      const days = Math.trunc(diffInSecs / 86400);

      return formatter.format(days, 'day');
    }

    case absDiffInSecs >= 604800 && absDiffInSecs < 2592000: {
      const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      const weeks = Math.trunc(diffInSecs / 604800);

      return formatter.format(weeks, 'week');
    }

    case absDiffInSecs >= 2592000 && absDiffInSecs < 31536000: {
      const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      const months = Math.trunc(diffInSecs / 2592000);

      return formatter.format(months, 'month');
    }

    case absDiffInSecs >= 31536000: {
      const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      const years = Math.trunc(diffInSecs / 31536000);

      return formatter.format(years, 'year');
    }

    default:
      return '';
  }
}
